module.exports = __webpack_public_path__ + "img/Pierre_Varignon.d0aab0ba.jpg";